import { Controller } from "@hotwired/stimulus";
import bsCustomFileInput from "bs-custom-file-input";
export default class default_1 extends Controller {
    connect() {
        bsCustomFileInput.init();
        this.setNoImage();
    }
    validateFile(event) {
        if (!(event.target instanceof HTMLInputElement) ||
            event.target.type !== "file") {
            return;
        }
        const inputFile = event.target;
        inputFile.setCustomValidity("");
        if (inputFile.files && inputFile.files.length > 0) {
            if (inputFile.files[0].size > this.maxFileSizeValue) {
                event.stopImmediatePropagation();
                inputFile.setCustomValidity(`El tamaño máximo de archivo permitido es de: ${this.maxFileSizeValue / 1e6}MB.`);
                inputFile.reportValidity();
            }
        }
    }
    updatePreview(event) {
        if (!(event.target instanceof HTMLInputElement) ||
            event.target.type !== "file") {
            return;
        }
        const inputFile = event.target;
        if (inputFile.files && inputFile.files.length > 0) {
            const img = document.createElement("img");
            img.src = URL.createObjectURL(inputFile.files[0]);
            img.addEventListener("load", () => {
                URL.revokeObjectURL(img.src);
            });
            this.applyImagePreviewClass(img);
            this.imagePreviewTarget.innerHTML = "";
            this.imagePreviewTarget.appendChild(img);
        }
        else {
            this.setNoImage();
        }
    }
    setB64Preview(event) {
        if (event.detail.logo) {
            const img = document.createElement("img");
            img.src = `data:image/*;base64,${event.detail.logo}`;
            this.applyImagePreviewClass(img);
            (this.imagePreviewTarget.innerHTML = ""),
                this.imagePreviewTarget.appendChild(img);
        }
        else {
            this.setNoImage();
        }
    }
    setNoImage() {
        const template = document.getElementById(this.noImageTemplateIdValue);
        let noImageHtml = "";
        if (template && template instanceof HTMLTemplateElement) {
            noImageHtml = template.innerHTML;
        }
        this.imagePreviewTarget.innerHTML = noImageHtml;
    }
    applyImagePreviewClass(img) {
        if (this.hasImagePreviewClass) {
            img.classList.add(this.imagePreviewClass);
        }
    }
}
default_1.classes = ["imagePreview"];
default_1.targets = ["imagePreview"];
default_1.values = {
    noImageTemplateId: String,
    maxFileSize: Number,
};
//# sourceMappingURL=input_file_controller.js.map